/**
 * T092: Categories Service
 * API methods for category operations
 */

import { apiGet, apiPost, apiPatch, apiDelete } from './api'
import type { CategoryResponse, CategoryListResponse } from '@arcanum/core'

export type { CategoryResponse, CategoryListResponse }

export interface CategoryFilters {
  page?: number
  limit?: number
}

export interface CreateCategoryInput {
  name: string
}

export interface UpdateCategoryInput {
  name?: string
}

/**
 * List all categories
 */
export async function listCategories(params?: CategoryFilters): Promise<CategoryListResponse> {
  return apiGet<CategoryListResponse>('/api/v1/categories', params as Record<string, string | number | boolean | undefined>)
}

/**
 * Get a single category by ID
 */
export async function getCategory(id: string): Promise<CategoryResponse> {
  return apiGet<CategoryResponse>(`/api/v1/categories/${id}`)
}

/**
 * Create a new category
 */
export async function createCategory(input: CreateCategoryInput): Promise<CategoryResponse> {
  return apiPost<CategoryResponse>('/api/v1/categories', input)
}

/**
 * Update an existing category
 */
export async function updateCategory(id: string, input: UpdateCategoryInput): Promise<CategoryResponse> {
  return apiPatch<CategoryResponse>(`/api/v1/categories/${id}`, input)
}

/**
 * Delete a category
 */
export async function deleteCategory(id: string): Promise<void> {
  return apiDelete(`/api/v1/categories/${id}`)
}
